import styled, { keyframes } from 'styled-components';

// ==================== 动画定义 ====================
export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const scaleIn = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// ==================== 样式组件 ====================
export const PageWrapper = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 20px;
`;

export const Container = styled.div`
  background: white;
  border-radius: 20px;
  width: 100%;
  padding: 40px;
  animation: ${fadeIn} 0.5s ease-in;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h1 {
    color: #333;
    font-size: 32px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .subtitle {
    color: #666;
    font-size: 14px;
  }
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    height: 3px;
    background: #e0e0e0;
    z-index: 0;
  }
`;

export const ProgressLine = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  z-index: 1;
  transition: width 0.5s ease;
  width: ${props => props.width}%;
`;

export const ProgressStep = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  .step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: white;
    border: 3px solid ${props => props.active ? '#667eea' : props.completed ? '#4caf50' : '#e0e0e0'};
    background: ${props => props.active ? '#667eea' : props.completed ? '#4caf50' : 'white'};
    color: ${props => (props.active || props.completed) ? 'white' : '#999'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    transform: ${props => props.active ? 'scale(1.1)' : 'scale(1)'};
  }

  .step-label {
    font-size: 12px;
    color: ${props => props.active ? '#667eea' : '#999'};
    font-weight: ${props => props.active ? '600' : 'normal'};
    text-align: center;
    max-width: 80px;

    @media (max-width: 768px) {
      font-size: 10px;
      max-width: 60px;
    }
  }
`;

export const Content = styled.div`
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StatusCard = styled.div`
  display: ${props => props.active ? 'block' : 'none'};
  text-align: center;
  width: 100%;
  animation: ${slideIn} 0.4s ease;

  .status-icon {
    font-size: 80px;
    margin-bottom: 20px;
  }

  .status-title {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  .status-description {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 30px;
  }
`;

export const Button = styled.button`
  padding: 14px 40px;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 5px;

  ${props => props.variant === 'primary' && `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
    }
  `}

  ${props => props.variant === 'secondary' && `
    background: white;
    color: #667eea;
    border: 2px solid #667eea;

    &:hover {
      background: #f5f7ff;
      transform: translateY(-2px);
    }
  `}

  ${props => props.variant === 'success' && `
    background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(76, 175, 80, 0.6);
    }
  `}

  ${props => props.small && `
    padding: 8px 20px;
  `}
`;

export const InfoCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  text-align: left;

  h4 {
    color: #333;
    margin-bottom: 15px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  .info-label {
    color: #666;
    font-weight: 500;
  }

  .info-value {
    color: #333;
    font-weight: 600;
  }
`;

export const CertItems = styled.div`
  width: 100%;
  margin: 20px 0;
`;

export const CertItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 15px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(5px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
`;

export const CertItemLeft = styled.div`
  display: flex;
  align-items: center;

  .cert-item-icon {
    font-size: 30px;
    margin-right: 15px;
  }

  h3 {
    color: #333;
    margin-bottom: 5px;
  }

  p {
    color: #666;
    font-size: 14px;
  }
`;

export const CertStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StatusBadge = styled.span`
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: ${props => props.completed ? '#d4edda' : '#fff3cd'};
  color: ${props => props.completed ? '#155724' : '#856404'};
`;

export const ComparisonTable = styled.table`
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  th {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 15px;
    text-align: left;
    font-weight: 600;
  }

  td {
    padding: 15px;
    border-bottom: 1px solid #e0e0e0;
    color: #333;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover {
    background: #f8f9fa;
  }
`;

export const SuccessAnimation = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${scaleIn} 0.5s ease;

  &::before {
    content: '✓';
    font-size: 60px;
    color: white;
  }
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 20px auto;
`;

export const DebugPanel = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px;
  border-radius: 10px;
  font-size: 12px;
  z-index: 1000;

  h4 {
    margin-bottom: 10px;
    color: #ffd700;
  }

  button {
    background: #667eea;
    color: white;
    border: none;
    padding: 5px 10px;
    margin: 3px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 11px;

    &:hover {
      background: #764ba2;
    }
  }

  p {
    margin-top: 10px;
    font-size: 11px;
    color: #aaa;
  }
`;

export const UsersSection = styled.div`
  margin-top: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;

  h3 {
    text-align: center;
    margin-bottom: 32px;
    color: #2c3e50;
    font-size: 24px;
    font-weight: 600;
  }
`;

export const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const UserCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  .user-avatar {
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
  }

  .user-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
  }

  .user-role {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }
`;

